<template>
  <div class="mentIndex">
    <div class="home_con_index">
      <div style="width:306px"></div>
      <div class="mentCon">
        <div class="ment_title">对账和结算</div>
        <p>1.1 文件生成通知</p>
        <span
          >概述：该接口用于对账和结算文件生成后通知对方拉取文件。所有文件采用
          GBK 编码，并会有 BOM 头<br />
          接口名称：notification_check_order_generated<br />
          接口使用方法：1）聚能实现，基础设施运营商调用。2）客户归属运营商实现，聚能调用</span
        >
        <br />
        <img src="@/assets/ment/11.png" alt="" />
        <p>1.2 密钥管理和使用</p>
        <small>请求参数：</small>
        <img src="@/assets/ment/333/22/1.png" alt="" />
        <small>FileOperatorMap 结构：</small>
        <img src="@/assets/ment/333/22/2.png" alt="" />
        <small>FileOperatorMap 结构：</small>
        <img src="@/assets/ment/333/22/3.png" alt="" />

        <p>1.2 对账订单文件格式</p>
        <span
          >概述：<br />
          1、设备运营方将文件上传到服务器，通过文件生成通知接口告知聚能拉取，该通知应在每日00:00~02:00之间发出，上传的文件中可以包含过去30天内所有未对账或对账失败的订单。<br />
          2、聚能将文件上传到服务器，通过文件生成通知接口告知用户运营方拉取。该通知会在每日02:30~03:00之间发出<br />
        </span>
        <span style="color: #f25643"
          >如果设备运营商不发起对账，将无法收到结算款</span
        >

        <small>文件格式：</small>
        <img src="@/assets/ment/333/22/4.png" alt="" />
        <small> 参数说明：</small>
        <img src="@/assets/ment/333/22/5.png" alt="" />

        <p>1.3 对账结果文件格式</p>
        <span
          >概述：<br />
          1、用户运营方将对账结果文件上传到服务器，通过文件生成通知接口告知聚能拉取，该通知应在每日04:00之前发出，超过时间的通知会被视为无效。<br />
          2、聚能将文件上传到服务器，通过文件生成通知接口告知设备运营方拉取。该通知会在每日04:00~04:30之间发出</span
        >
        <br />
        <small>文件格式：</small>
        <img src="@/assets/ment/333/22/6.png" alt="" />
        <span
          >注：因各个接入方的金额计算过程中，四舍五入或位数精度各不同，可能会导致总额误差。故为了降低接入方改造难度，用户运营商如果根据单价、电量自己计算金额并做校验，需要允许设备运营方的账单结果与自身计算结果误差最大±0.01
          元，此时以设备运营方金额为准。只有当误差大于 0.01
          元，用户运营商才返回交易金额错误</span
        >
        <br />
        <p>1.4 清分结算明细</p>
        <span
          >概述：聚能将打款明细上传到聚能服务器，客户归属运营商和基础设施运营商拉取使用，通过文件生成通知中的文件类型，区分该文件是付款明细还是收款明细</span
        >
        <small>文件格式：</small>
        <img src="@/assets/ment/333/22/7.png" alt="" />
        <small>文件格式：</small>
        <img src="@/assets/ment/333/22/8.png" alt="" />

        <p>2.聚能订单号查询</p>
        <span
          >概述：此接口用于客户归属运营商根据订单号查询聚能内部订单号使用，主要用于用户进线后直接向基础设施运营商查询订单问题。<br />
          接口名称：query_uniev_order_no<br />
          接口使用方法：由聚能实现，客户归属运营商调用</span
        >
        <br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/22/9.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/22/10.png" alt="" />

        <p>3.申请开票</p>
        <span
          >概述：当客人针对跨平台订单请求开票时，客户归属运营商根据自身情况判定是否可支持用户开票，如需转到设备方运营商开票，调此接口发起，由聚能转发。目前暂不支持一张订单拆分多次开票。默认普票为电子票，专票为纸质票<br />
          接口名称：apply_invoice<br />
          接口使用方法：聚能实现，客户归属运营商调用。并建议设备方运营商也实现，聚能调用</span
        ><br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/22/11.png" alt="" />
        <small>InvoiceOrder 构造体：</small>
        <img src="@/assets/ment/333/22/12.png" alt="" />
        <small>返回值：</small>
        <img src="@/assets/ment/333/22/13.png" alt="" />
        <small>发票申请批次构造（Batch）：</small>
        <img src="@/assets/ment/333/22/14.png" alt="" />
        <p>4.开票结果回调</p>
        <span
          >概述：当设备运营商开票成功\失败，聚能通过本接口把开票结果通知给用户运营商。如果开票申请中包括了多个运营商的订单，或者同一个运营商订单分多次开票，会分多次通知开票结果。如果无法开专票或电子普票，会返回开票失败的结果，由客服介入解决，详细流程参见运营规范<br />
          接口名称：notification_invoice_result<br />
          接口使用方法：客户归属运营商实现，聚能调用</span
        ><br />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/22/15.png" alt="" />
        <small>请求参数：</small>
        <img src="@/assets/ment/333/22/16.png" alt="" />
      </div>
    </div>
  </div>
</template>


<script>
import Ment from "@/components/ment";
export default {
  components: {
    Ment,
  },
};
</script>

<style scoped>
.home_con_index {
  display: flex;
  text-align: left;
 
}
.mentCon small {
  margin: 23px 0px 12px 0px;
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 12px;
}
.mentCon img {
  margin: 0px;
}
</style>


// WEBPACK FOOTER //
// src/page/document/documentg.vue